// Body scroll management utility to prevent scroll lock issues
export const restoreBodyScroll = () => {
  setTimeout(() => {
    requestAnimationFrame(() => {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
      document.body.classList.remove('modal-open')
      if (!('ontouchstart' in window)) {
        void document.body.offsetHeight
      }
    })
  }, 100)
}
